import type { CreateEmployeeInput, EmployeeFormValues } from "../types";

/**
 * Forma qiymatlari → `POST /employees` tanasi. `EmployeesPage` va bo'lim
 * profilining Xodimlar tabi (`DepartmentEmployeesTab`) bir xil shaklda
 * yuborishi uchun yagona joy.
 *
 * Telefon — yaratishda majburiy; forma validatsiyasidan o'tmagan holatda
 * (`phone` yo'q) `null` qaytadi va chaqiruvchi so'rov yubormaydi.
 */
export function toCreateEmployeeInput(values: EmployeeFormValues): CreateEmployeeInput | null {
	if (!values.phone) {
		return null;
	}

	return {
		fullName: values.fullName,
		phone: values.phone,
		idCode: values.idCode?.trim() ? values.idCode.trim() : undefined,
		positionId: values.positionId,
		departmentId: values.departmentId,
		managerId: values.managerId,
		hrStatus: values.hrStatus,
	};
}
